import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import type { PromoCode, CreatePromoCodePayload } from '../types/promoCode';
import { promoCodeQueryKeys } from './usePromoCodes';

export function useCreatePromoCode(
  options?: UseMutationOptions<PromoCode, Error, CreatePromoCodePayload>,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['promoCode', 'create'],
    mutationFn: async (payload: CreatePromoCodePayload) => {
      return service.createPromoCode(payload);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: promoCodeQueryKeys.all });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
